export default __webpack_public_path__ + "static/media/img-6.8ac69291.png";